module.exports = __webpack_public_path__ + "img/0007.ab7ec081.png";